import React, { useEffect, useState } from "react";
import * as RB from "react-bootstrap";
import * as utils from "../../Utils/comman";
import { Link } from "react-router-dom";
import Select from "react-select";
import StatusModal from "./StatusModal";
import { Eye } from "iconsax-react";
import { filter } from "lodash";
import BomProcess from "./BomProcess";

function Add(props) {
  const [productOptions, setProductOptions] = useState([]);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [validated, setValidated] = useState(false);
  const [isSubmit, setIsSubmit] = useState(false);
  const [isBomProcess, setIsBomProcess] = useState(false);
  const [isEdit, setisEdit] = useState(false);
  const [batchNo, SetBatchNo] = useState("");
  const [plantList, setPlantList] = useState([]);
  const [plantLocation, setPlantLocation] = useState("");
  const [batchList, setBatchList] = useState([]);
  const [batchSize, setBatchSize] = useState("");
  const [bomList, setBomList] = useState([]);
  const [filteredBom, setFilterdBom] = useState([]);
  const [selectedBom, setSelectedBom] = useState("");
  const [selectedStatus, setSelectedStatus] = useState("");
  const [isBom, setIsBom] = useState(false);
  const [list, setList] = useState([]);
  const [isfromRd, setIsFromRD] = useState(false);
  useEffect(() => {
    getProductList();
    getPlantList();
  }, []);

  const getPlantList = () => {
    utils
      .callAPI("get", `/purchaseorder/plant/list`)
      .then((res) => {
        if (typeof res !== "undefined") {
          setPlantList(res?.result);
        } else {
          setPlantList([]);
        }
      })
      .catch((err) => {
        setPlantList([]);
      });
  };

  const getProductList = () => {
    utils
      .callAPI("get", `/Product/list`)
      .then((res) => {
        setProductOptions(res);
      })
      .catch(() => setProductOptions([]));
  };

  const options = productOptions?.result?.map((prod) => ({
    value: prod.id,
    label: prod.productCode
      ? `${prod.product_name} - (${prod.productCode}) - ${prod?.size} ${prod?.unit?.toUpperCase() || ""}`
      : prod.product_name,
    productCode: prod.productCode,
  }));

  const handleProductSelection = (selected) => {
    if (isBomProcess) {
      setIsBomProcess(!isBomProcess);
    }
    setPlantLocation("");
    setBatchSize("");
    setSelectedBom("");
    setSelectedStatus("");
    setSelectedProduct(selected);

    if (selected) {
      const productId = selected.value;
      utils
        .callAPI(
          "get",
          `/production/batch/get-batch-details?product_id=${productId}`
        )
        .then((res) => {
          if (Array.isArray(res) && res.length > 0) {
            setBatchList(res);
          } else {
            setBatchList([]);
          }
        })
        .catch((err) => {
          // setBatchList([]);
        });
    }
  };

  const handleBatchChange = (e) => {
    const selectedBatchNo = e.target.value;
    SetBatchNo(selectedBatchNo);
    const selectedBatch = batchList.find(
      (batch) => batch.batch_no_id === selectedBatchNo
    );

    if (selectedBatch) {
      setPlantLocation(selectedBatch.plant_id);
      setBatchSize(selectedBatch.batch_size);
      setIsBom(true);
    } else {
      setPlantLocation("");
      setBatchSize("");
    }
  };

  useEffect(() => {
    if (isBom) {
      getBOMList();
    }
  }, [isBom]);

  const getBOMList = () => {
    utils
      .callAPI(
        "get",
        `/production/bom/get-bom-details?product_id=${selectedProduct?.value}&plant_id=${plantLocation}`
      )
      .then((res) => {
        if (res) {
          // setBomList(res);
          setList(res);
          const combinedBomList = [
            ...(res?.raw_materials || []),
            ...(res?.consumable_items || []),
            ...(res?.finished_goods || []),
          ];
          // Process BOM for all three categories
          const processedBomList = processBomList(combinedBomList);

          setFilterdBom(processedBomList);
          if (!isEdit) {
            if (processedBomList.length > 0) {
              setSelectedBom(processedBomList[0].id);
              setSelectedStatus(processedBomList[0].status);
            }
          }
          setIsBom(false);
        } else {
          setIsBom(false);
        }
      })
      .catch((err) => {
        // setBatchList([]);
      });
  };

  const processBomList = (bomList) => {
    const idMap = new Map();

    bomList.forEach((bom) => {
      const { id, status, ci_status, fg_status } = bom;

      if (!idMap.has(id)) {
        idMap.set(id, {
          ...bom,
          status:
            status === "Not Available" ||
            ci_status === "Not Available" ||
            fg_status === "Not Available"
              ? "Not Available"
              : "Available",
        });
      } else {
        const existingBom = idMap.get(id);
        if (
          status === "Not Available" ||
          ci_status === "Not Available" ||
          fg_status === "Not Available"
        ) {
          existingBom.status = "Not Available";
        }
      }
    });

    return Array.from(idMap.values());
  };

  const handleBomSelection = (e) => {
    setIsBomProcess(false);
    const selectedBomId = e.target.value;
    setSelectedBom(selectedBomId);

    const selectedBOM = filteredBom.find((bom) => bom.id === selectedBomId);
    if (selectedBOM) {
      setSelectedStatus(selectedBOM.status);
    }
  };

  const [showModal, setShowModal] = useState(false);
  const handleEyeClick = () => {
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const form = e.currentTarget;
    if (form.checkValidity() === false) {
      e.stopPropagation();
      setValidated(true);
    } else {
      // if (selectedStatus === "Not Available") {
      setIsSubmit(true);
      // } else {
      // }
    }
  };

  const hanldeBOMProcess = () => {
    setIsBomProcess(!isBomProcess);
  };

  useEffect(() => {
    if (isSubmit) {
      const formData = new FormData();
      if (props.rowData && Object.keys(props.rowData).length > 0) {
        formData.append("id", props.rowData.id);
      }
      formData.append("product_id", selectedProduct?.value);
      formData.append("batch_no_id", batchNo);
      formData.append("plant_id", plantLocation);
      formData.append("batch_size", batchSize);
      formData.append("bom_stock_status", selectedStatus);
      formData.append("RND_or_process_status", "1");
      formData.append("bom_id", selectedBom);
      formData.append("bom_screen", "");

      utils
        .callAPI("post", `/production/process/save`, formData)
        .then((res) => {
          setIsSubmit(false);
          props.onChange({ mode: "list" });
        })
        .catch((err) => {
          setIsSubmit(false);
        });
    }
  }, [isSubmit]);

  useEffect(() => {
    if (props.rowData && Object.keys(props.rowData).length > 0) {
      setisEdit(true);
      const {
        product_id,
        batch_no_id,
        plant_id,
        batch_size,
        bom_id,
        bom_stock_status,
        product_name,
        batch_no,
        plant_name,
        bom_name,
        bom_recipe,
        bom_screen,
      } = props.rowData;

      utils
        .callAPI(
          "get",
          `/production/batch/get-batch-details?product_id=${product_id}`
        )
        .then((res) => {
          if (Array.isArray(res) && res.length > 0) {
            setBatchList(res);
          } else {
            setBatchList([]);
          }
        })
        .catch((err) => {
          // setBatchList([]);
        });
      setSelectedProduct({
        value: product_id,
        label: `${product_name}`,
      });
      setIsBom(true);
      SetBatchNo(batch_no_id);
      setPlantLocation(plant_id);
      setBatchSize(batch_size);
      setSelectedBom(bom_id);
      setSelectedStatus(bom_stock_status);

      if (bom_screen?.length !== 0) {
        setBomList(bom_screen);
        setIsBomProcess(true);
      } else {
        setIsFromRD(true);
      }
    } else {
      setisEdit(false);
    }
  }, [props.rowData]);

  useEffect(() => {
    if (isfromRd) {
      const parseBatchSize = (batchSize) =>
        parseFloat(batchSize?.replace(/[^\d.]/g, "")) || 0;
      const numericBatchSize = parseBatchSize(batchSize);
      const formattedData = formatBomList(list, selectedBom, numericBatchSize);
      console.log(formattedData)
      setBomList(formattedData);
    }
  }, [isfromRd,list]);

  const formatBomList = (data, selectedBomId, numericBatchSize) => {
    let formattedList = [];
    // Function to filter only the selected BOM
    const filterSelectedBom = (items, key) =>
      items?.filter((item) => item[key] === selectedBomId) || [];

    // Process raw materials for the selected BOM
    if (data?.raw_materials?.length) {
      formattedList = [
        ...formattedList,
        ...filterSelectedBom(data.raw_materials, "id").map((item) => ({
          id: 0,
          item_id: item.itemId,
          product_name: item.item_name,
          product_code: item.item_code,
          auto_qty: (numericBatchSize * item.qty) / 100,
          actual_qty: "",
          remark: "",
          unit_id: item.unit_id,
          unit_name: item.unit_name,

          item_type: "raw_material",
        })),
      ];
    }

    // Process finished goods for the selected BOM
    if (data?.finished_goods?.length) {
      formattedList = [
        ...formattedList,
        ...filterSelectedBom(data.finished_goods, "id").map((item) => ({
          id: 0,
          item_id: item.fg_itemId,
          product_name: item.fg_item_name,
          product_code: item.fg_item_code,
          auto_qty: (numericBatchSize * item.fg_qty) / 100,
          actual_qty: "",
          remark: "",
          unit_id: item.fg_unit_id,
          unit_name: item.fg_unit_name,
          item_type: "finish_good",
        })),
      ];
    }

    // Process consumable items for the selected BOM
    if (data?.consumable_items?.length) {
      formattedList = [
        ...formattedList,
        ...filterSelectedBom(data.consumable_items, "id").map((item) => ({
          id: 0,
          item_id: item.ci_itemId,
          product_name: item.ci_item_name,
          product_code: item.ci_item_code,
          auto_qty: (numericBatchSize * item.ci_qty) / 100,
          actual_qty: "",
          remark: "",
          unit_id: item.ci_unit_id,
          unit_name: item.ci_unit_name,
          item_type: "consumable_item",
        })),
      ];
    }

    return formattedList;
  };

  const finalData = {
    id: props?.rowData?.id ? props?.rowData?.id : "",
    selectedProduct: selectedProduct?.value,
    selectedBatch: batchNo,
    selectedPlantLocation: plantLocation,
    batchSize: batchSize,
    selectedStatus: selectedStatus,
    selectedBom: selectedBom,
  };
  const [selectedBatch, setselectedBatch] = useState([]);
  // const selectedBatch = batchList.find(
  //   (batch) => batch.batch_no_id === batchNo
  // );

  useEffect(() => {
    setselectedBatch(batchList.find((batch) => batch.batch_no_id === batchNo));
  }, [batchNo]);
  return (
    <>
      <div className="section-body">
        <RB.Card className="card shadow">
          <RB.Card.Header>
            <h4></h4>
            <div className="card-header-action">
              <Link
                className="btn btn-underline me-2"
                onClick={() => props.onChange({ mode: "list" })}
              >
                Back
              </Link>
            </div>
          </RB.Card.Header>
          <RB.Card.Body>
            <RB.Form noValidate validated={validated} onSubmit={handleSubmit}>
              <RB.Row>
                <RB.Col md={6}>
                  <div className="mt-3">
                    <RB.FloatingLabel
                      controlId="productName"
                      className="floating-label-fancy"
                      // label="Product Name"
                    >
                      <Select
                        options={options}
                        value={selectedProduct}
                        onChange={handleProductSelection}
                        placeholder="Select Product Name"
                        className="bom-productName-select"
                        classNamePrefix="select"
                        isClearable
                        required
                        isDisabled={isEdit}
                      />
                    </RB.FloatingLabel>
                  </div>
                </RB.Col>
                <RB.Col md={6}>
                  <div className="mb-3">
                    <RB.FloatingLabel
                      controlId="plantLocation"
                      //   label="Batch No."
                      className="floating-label-fancy"
                    >
                      <RB.Form.Select
                        value={batchNo}
                        onChange={handleBatchChange}
                        required
                        disabled
                      >
                        <option value="">Batch No.</option>
                        {batchList
                          // .filter((batch) => batch.status === '0')
                          .map((batch) => (
                            <option
                              key={batch.batch_no_id}
                              value={batch.batch_no_id}
                            >
                              {`${batch.batch_no}`}
                            </option>
                          ))}
                      </RB.Form.Select>
                      <RB.Form.Control.Feedback type="invalid">
                        Please select a plant location.
                      </RB.Form.Control.Feedback>
                    </RB.FloatingLabel>
                  </div>
                </RB.Col>
                <RB.Col md={6}>
                  <div className="mb-3">
                    <RB.FloatingLabel
                      controlId="plantLocation"
                      // label="Plant Location/Code"
                      className="floating-label-fancy"
                    >
                      <RB.Form.Select
                        value={plantLocation}
                        onChange={(e) => setPlantLocation(e.target.value)}
                        required
                        disabled
                      >
                        <option value="">Plant Location/Code</option>
                        {plantList.map((plant) => (
                          <option key={plant.id} value={plant.id}>
                            {plant.plant_name}
                          </option>
                        ))}
                      </RB.Form.Select>
                      <RB.Form.Control.Feedback type="invalid">
                        Please select a plant location.
                      </RB.Form.Control.Feedback>
                    </RB.FloatingLabel>
                  </div>
                </RB.Col>
                <RB.Col md={6}>
                  <div className="mb-3">
                    <RB.FloatingLabel
                      label="Batch Size"
                      className="floating-label-fancy"
                    >
                      <RB.Form.Control
                        type="text"
                        placeholder="Enter Batch Size"
                        readOnly
                        value={batchSize}
                      />
                    </RB.FloatingLabel>
                  </div>
                </RB.Col>
                <RB.Col md={6}>
                  <div className="mb-3">
                    <RB.FloatingLabel
                      controlId="plantLocation"
                      // label="Plant Location/Code"
                      className="floating-label-fancy"
                    >
                      <RB.Form.Select
                        value={selectedBom}
                        onChange={handleBomSelection}
                        required
                      >
                        <option value="">Select Bom</option>
                        {filteredBom.map((plant) => (
                          <option key={plant.id} value={plant.id}>
                            {plant.bom_name}
                          </option>
                        ))}
                      </RB.Form.Select>
                    </RB.FloatingLabel>
                  </div>
                </RB.Col>

                <RB.Col md={6}>
                  <div className={`mb-3 d-flex align-items-center`}>
                    <RB.FloatingLabel
                      label="Bom Status"
                      className={`floating-label-fancy  w-75`}
                    >
                      <RB.Form.Control
                        type="text"
                        placeholder="Bom Status"
                        className={`${
                          selectedStatus === "Not Available"
                            ? "text-danger"
                            : "text-success"
                        }`}
                        readOnly
                        value={selectedStatus}
                      />
                    </RB.FloatingLabel>
                    {/* {selectedStatus === "Not Available" && ( */}
                    <div className="ms-2 w-25 text-center ">
                      <RB.Button
                        className="btn btn-flat ms-1"
                        onClick={handleEyeClick}
                      >
                        <Eye />
                      </RB.Button>
                    </div>
                    {/* )} */}
                  </div>
                </RB.Col>
              </RB.Row>

              <div className="text-end mt-3">
                {selectedStatus === "Not Available" && (
                  <RB.Button
                    type="submit"
                    variant="primary"
                    className="ms-1"
                    disabled={
                      props?.rowData?.RND_or_process_status == "1" ||
                      props?.rowData?.RND_or_process_status == "2"
                    }
                  >
                    Send to R & D
                  </RB.Button>
                )}
                {selectedStatus === "Available" && (
                  <RB.Button
                    variant="primary"
                    className="ms-1"
                    onClick={hanldeBOMProcess}
                    disabled={!selectedBom}
                  >
                    Bom Process
                  </RB.Button>
                )}
                {props?.rowData?.RND_or_process_status == "2" && (
                  <RB.Button
                    variant="primary"
                    className="ms-1"
                    onClick={hanldeBOMProcess}
                    disabled={!selectedBom}
                  >
                    Bom Process
                  </RB.Button>
                )}
              </div>
            </RB.Form>
            {isBomProcess && (
              <BomProcess
                setIsBomProcess={setIsBomProcess}
                bomList={bomList}
                selectedBOM={selectedBom}
                selectedProduct={selectedProduct}
                batchSize={batchSize}
                selectedBatch={selectedBatch}
                finalData={finalData}
                props={props}
              />
            )}
          </RB.Card.Body>
        </RB.Card>
      </div>
      <StatusModal
        show={showModal}
        handleClose={handleCloseModal}
        bomList={list}
        selectedBOM={selectedBom}
        batchSize={batchSize}
      />
    </>
  );
}

export default Add;
